export const getPromisifiedActionsResults = (state) =>
  state.promisifiedActionsResults || {};
